<template>
  <div>
    <PageHeader title="รายงานข้อมูลนักเรียน"></PageHeader>
    <b-container class="mt-5">
      <div class="section-container">
        <div class="search-section">
          <p>กรุณาระบุข้อมูลที่ต้องการดาวน์โหลดรายงาน</p>
          <b-row>
            <b-col cols="3">
              <label><strong>วันที่ลงทะเบียน</strong></label>
              <div class="date-range-field">
                <b-input-group>
                  <b-form-input
                    size="sm"
                    type="text"
                    :value="formatEnrollDate"
                    placeholder="เลือกวันที่ลงทะเบียน"
                    disabled
                  />
                  <b-input-group-prepend>
                    <b-button
                      size="sm"
                      variant="secondary"
                      @click="showCalendarRange('enroll-date')"
                    >
                      <b-icon icon="calendar-range"></b-icon>
                    </b-button>
                  </b-input-group-prepend>
                </b-input-group>
                <DatePicker
                  v-model="enrollDate"
                  locale="th"
                  id="enroll-date"
                  style="
                    display: none;
                    float: right;
                    position: relative;
                    will-change: transform;
                    left: 0px;
                  "
                  is-range
                />
              </div>
            </b-col>
            <b-col cols="3">
              <label><strong>สถานะ</strong></label>
              <b-form-select
                v-model="selectedStatus"
                :options="statusList"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-button @click="searchQuery()" class="search-btn" variant="primary">
            <b-icon icon="search"></b-icon>
            ค้นหาข้อมูล
          </b-button>
        </div>

        <div v-if="isShowTable" class="table-section">
          <div class="table-title">
            <p>
              <strong>รายละเอียดข้อมูลทะเบียนนักเรียน</strong> ข้อมูลทั้งหมด
              {{ studentInfo.length }}
              ข้อมูล
            </p>
            <b-button variant="primary">
              <b-icon icon="chevron-double-down"></b-icon>
              ดาวน์โหลดรายงาน pdf
            </b-button>
          </div>
          <p class="remark-text">
            หมายเหตุ : ระบบทำการ generate report เป็นไฟล์ pdf
            และดาวน์โหลดลงบนเครื่องของคุณ
          </p>
          <b-table
            id="student-info-report"
            :fields="fields"
            :items="studentInfo"
            :per-page="perPage"
            :current-page="currentPage"
            responsive
            style="font-size: 14px; border:hidden;"
            :busy="isDataTableLoading"
            hover
            bordered
            show-empty
          >
            <template #empty>
              <p class="text-center py-3">ไม่มีข้อมูล</p>
            </template>
          </b-table>
          <b-row class="mt-3" v-if="studentInfo.length > 0">
            <b-col cols="6">
              <form class="form-inline">
                <div class="form-group mb-2">
                  <label>แสดง</label>
                </div>
                <div class="form-group ml-2 mb-2">
                  <b-form-select v-model="perPage" size="sm">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                  </b-form-select>
                </div>
                <div class="form-group ml-2 mb-2">
                  <label>
                    จาก
                    {{ studentInfo.length }}
                    รายการ
                  </label>
                </div>
              </form>
            </b-col>
            <b-col cols="6" v-if="studentInfo.length > 0">
              <nav class="float-right">
                <b-pagination
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="studentInfo.length"
                  aria-controls="student-info-report"
                  last-number
                >
                </b-pagination>
              </nav>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import PageHeader from "../../layouts/PageHeader";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import moment from "moment";

export default {
  components: { PageHeader, DatePicker },
  data() {
    return {
      enrollDate: {
        start: "",
        end: "",
      },
      selectedStatus: "",
      statusList: [
        { value: "", text: "สถานะทั้งหมด" },
        { value: "", text: "เปิดใช้งาน" },
        { value: "", text: "ระงับการใช้งาน" },
      ],
      isShowTable: false,
      studentInfo: [],
      fields: [
        {
          label: "รหัสนักเรียน",
          key: "studentId",
          formatter: (value) => {
            return value || "-";
          },
        },
        {
          label: "ชื่อนักเรียน",
          key: "studentName",
        },
        {
          label: "วันที่ลงทะเบียน",
          key: "enrollDate",
        },
        {
          label: "โรงเรียน",
          key: "schoolName",
        },
        {
          label: "E-Mail",
          key: "email",
        },
        {
          label: "บัตรประชาชน",
          key: "idCard",
        },
        {
          label: "วันเดือนปีเกิด",
          key: "dateOfBirth",
        },
      ],
      perPage: 10,
      currentPage: 1,
    };
  },
  computed: {
    formatEnrollDate() {
      return this.getFormattedRange(
        this.enrollDate.start,
        this.enrollDate.end,
        "enroll-date",
      );
    },
  },
  mounted() {
    this.setDefaultDates();
  },
  methods: {
    searchQuery() {
      let params = {
        status: this.selectedStatus,
        startDate: this.enrollDate.start
          ? moment(this.enrollDate.start).format("YYYY-MM-DD")
          : "",
        endDate: this.enrollDate.end
          ? moment(this.enrollDate.end).format("YYYY-MM-DD")
          : "",
      };

      console.log(params);
      //   await this.fetch(params);
      this.isShowTable = true;
    },
    setDefaultDates() {
      const dateFormat = "YYYY-MM-DD";
      const currentDate = moment();
      const ninetyDaysAgo = moment(currentDate).subtract(90, "days");

      this.enrollDate.start = ninetyDaysAgo.format(dateFormat);
      this.enrollDate.end = currentDate.format(dateFormat);
    },
    getFormattedRange(startDate, endDate, calendarId) {
      if (!startDate) return "";

      const rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar && rangeCalendar.style.display === "inline-block") {
        this.showCalendarRange(calendarId);
      }

      const start = moment(startDate).format("DD/MM/YYYY");
      const end = moment(endDate).format("DD/MM/YYYY");
      return `${start} - ${end}`;
    },
    showCalendarRange(calendarId) {
      let rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar.style.display == "inline-block") {
        rangeCalendar.style.display = "none";
      } else {
        rangeCalendar.style.display = "inline-block";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.section-container,
.search-section {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.search-section {
  .date-range-field,
  .date-field {
    .form-control:disabled {
      background-color: #fff;
    }
  }

  .search-btn {
    width: fit-content;
  }
}

.table-section {
  display: flex;
  flex-direction: column;
  gap: 25px;

  .table-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  .remark-text {
    color: #ffc107;
  }
}
/* Calendar */
.vc-container {
  position: absolute !important;
  right: 0 !important;
  left: initial !important;
  margin-right: 13px;
  z-index: 99;
}

/* Target the input search and its placeholder */
::v-deep .vs__search,
::v-deep .vs__search::placeholder {
  margin: 0;
  padding: 3px 3px 2px;
  font-size: 14px;
}
</style>

<style>
/* text field height */
.date-range-field .form-control,
.vs__dropdown-toggle {
  height: 38px;
}

.vs__dropdown-toggle {
  align-items: center;
}

.vs__clear {
  margin-bottom: 6px;
}

.custom-select {
  height: 38px !important;
  padding: 0 1.75rem 0 0.75rem;
  font-size: 14px !important;
}
</style>
